<div class="progress-circle ml-auto" *ngIf="!higherDaysLeft">
  <svg viewBox="0 0 94 94">
    <circle class="progress-circle-background" cx="47" cy="47" r="45"></circle>
    <circle class="progress-bar-circle" [ngClass]="{'expired': isExpiring}" cx="47" cy="47" r="45"
      [attr.stroke-dashoffset]="calculateOffset()" aria-label="countdown ring"></circle>
  </svg>
  <span class="progress-circle-text" [ngClass]="{'expired': isExpiring}">
    <div class="gb-headline3 heavy">
      <p>{{numberOfDaysLeft}}</p>
    </div>
    <div class="gb-body4 d-flex flex-column align-items-center" style="font-size: 12px;">
      <p>{{days}}</p>
      <p>{{left}}</p>
  </div>
  </span>
</div>

